import { FC } from "react";
import CreateMeasurementDefinition from "@/components/measurementDefinition/createMeasurementDefinition";
import RestrictedPage from "@/consumer/restrictedPage";

const MeasurementDefinitionCreate: FC = () => {
  return (
    <RestrictedPage permissionRequired="frontend_view_measurement_definition">
      <CreateMeasurementDefinition />
    </RestrictedPage>
  );
};

export default MeasurementDefinitionCreate;
